import { render, staticRenderFns } from "./RestaurantSettlementDetails.vue?vue&type=template&id=0ecc5cbc&"
import script from "./RestaurantSettlementDetails.vue?vue&type=script&lang=js&"
export * from "./RestaurantSettlementDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports